import React from 'react'
import { CompetitionsBoardContent } from './CompetitionsBoardContent'
import { CampaignModalsProvider } from './CompetitionModalsManagerContext'

export const CompetitionsBoard: React.FC = () => {
  return (
    <CampaignModalsProvider>
      <CompetitionsBoardContent />
    </CampaignModalsProvider>
  )
}
